package meineglasfaser.frontend.www.components.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.rememberPageContext
import io.ktor.client.call.*
import meineglasfaser.api.routes.IncidentRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.BootstrapIcon
import meineglasfaser.frontend.common.components.widgets.INCIDENT_LEVEL_STRINGS
import meineglasfaser.frontend.common.components.widgets.INCIDENT_STATUS_STRINGS
import org.jetbrains.compose.web.dom.*

@Composable
fun IncidentBanner() {
    val ctx = rememberPageContext()
    var data by remember { mutableStateOf<IncidentRoutes.Public.ResponseBody?>(null) }

    LaunchedEffect(ctx.route.path) {
        data = BackendApi.get<IncidentRoutes.Public>(IncidentRoutes.Public())
            .fold(
                onSuccess = { response ->
                    response.body()
                },
                onFailure = { error ->
                    console.error("Failed to fetch incident data: $error")
                    null
                },
            )
    }

    data?.let { data ->
        if (data.incidents.isEmpty()) return@let
        Div({
            classes("incident-banner")
            attr("role", "alert")
        }) {
            data.incidents.forEach { incident ->
                var expanded by remember { mutableStateOf(true) }
                Article({ classes("bg-warn", "incident-card") }) {
                    Header({
                        if (!expanded) {
                            classes("incident-card-collapsed")
                        }
                    }) {
                        Div {
                            BootstrapIcon("exclamation-triangle-fill")
                            Text(" Störung: ")
                            Text(incident.title)
                        }
                        Button(attrs = {
                            classes("ghost", "toggle-btn")
                            onClick { expanded = !expanded }
                            attr("style", "margin-left: 8px;")
                        }) {
                            Text(if (expanded) "Weniger anzeigen" else "Mehr anzeigen")
                        }
                    }
                    if (expanded) {
                        Div {
                            Text("Betroffenes Netz: ")
                            Text(incident.affectedName)
                        }
                        Div {
                            Text("Level: ")
                            Text(INCIDENT_LEVEL_STRINGS[incident.level].toString())
                        }
                        Div {
                            Text("Status: ")
                            Text(INCIDENT_STATUS_STRINGS[incident.status].toString())
                        }
                        if (incident.message.isNotBlank()) {
                            Div {
                                Text("===========================")
                                Br()
                                Text(incident.message)
                            }
                        }
                    }
                }
            }
        }
    }
}
